/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { TimerService } from 'src/refresh/service/timer-service';
import { InputData } from '../_common/data/input-data';
import { Path } from  "../_common/constant/page-const";
import { AboutTheParentsScreenComponent } from './about_the_parents_screen.component';
import { ItemList } from '../_common/constant/item-list';
import { ProgressService } from 'src/refresh/service/progress-service';
import { ViewportScroller } from '@angular/common';

@Component({ 
      selector: 'about_the_parent_screen_3',
      templateUrl: './about_the_parents_screen.component.html',
      styleUrls:  ['./about_the_parents_screen.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class AboutTheParentsScreen3Component extends AboutTheParentsScreenComponent implements OnInit {

       constructor( public  router: Router,
                    public  timerService:TimerService,
                    public  items:ItemList,  
                    protected progress:ProgressService,
                    public viewportScroller: ViewportScroller,
                    public  data:InputData ) {

                    super(router,timerService,data,items,viewportScroller,2);  

                    if ( this.parentCount > 3 ) {
                         super.setNextPage(Path.AboutTheParentsScreen4,Path.AboutTheParentsScreen2);
                    }
                    else super.setNextPage(Path.ContactInfoAndMailingAddress,Path.AboutTheParentsScreen2);
       }

       public ngOnInit() { super.init(); }
}
